import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  sectionHeader: {
    marginHorizontal: 16,
    marginTop: 28,
  },
  scrollViewContentContainerWithTray: {
    marginTop: 33,
  },
  divider: theme => ({
    height: 1,
    width: '100%',
    backgroundColor: theme.colors.dividerTwo,
    marginBottom: 10,
    paddingHorizontal: 16,
  }),
  dividerContainer: {
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  addOnsListContainer: {
    paddingHorizontal: 16,
  },
  titleStyle: {
    fontSize: 24,
  },
  subTitleStyle: {
    fontSize: 16,
    marginBottom: 25.29,
  },
  errorBackgroundStyle: {
    marginTop: '20%',
  },
  errorTextStyle: {
    marginTop: 24,
    marginBottom: 20,
    marginHorizontal: 28,
  },
  errorHeaderStyle: {
    backgroundColor: Colors.mono2,
    borderBottomWidth: 0,
  },
  statusBarStyle: {
    backgroundColor: Colors.mono2,
  },
});
